import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { topicTool } from './TopicTool';
import { TopicWidget } from './TopicWidget';

export const topicToolboxItem = ToolboxItem({
    id: 'topicTool',
    label: 'Topics',
    ui: TopicWidget,
    weight: 1030,
    tools: [
        topicTool
    ]
});
